"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPatientsRequest = void 0;
const api_1 = require("./api");
Object.defineProperty(exports, "fetchPatientsRequest", { enumerable: true, get: function () { return api_1.fetchPatientsRequest; } });
